import React, { useState, useEffect } from "react";
import { FiSearch } from "react-icons/fi";
import { MdVerified, MdOutlineKeyboardArrowRight } from "react-icons/md";
import CreateNewProduct from "./CreateNewProduct";
import { useLazyGetAllMedsQuery } from "../../State/Api/PharmacyStockApiSlice";

const SelectProductName = ({ isOpen, onClose, onSelectProductName, setIsModalOpen, formik, setSelectedProduct }) => {
 const [getMeds] = useLazyGetAllMedsQuery();
  const [searchTerm, setSearchTerm] = useState("");
  const [products, setProducts] = useState([]);
  const [selectedRow, setSelectedRow] = useState(0);

  // Track which modal is visible
  const [isSelectModalVisible, setIsSelectModalVisible] = useState(isOpen);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);

  // Keep parent state in sync
  useEffect(() => {
    setIsSelectModalVisible(isOpen);
  }, [isOpen]);

  useEffect(() => {
    if (!searchTerm.trim()) {
      setProducts([]);
      return;
    }

    const fetchFilteredProducts = async () => {
      try {
        const pharmaId = localStorage.getItem("userUniqueID");
        const response = await getMeds({ pharmaId, productname: searchTerm }).unwrap();
        setProducts(response || []);
      } catch (error) {
        console.error("Error fetching filtered products:", error);
        setProducts([]);
      }
    };

    fetchFilteredProducts();
  }, [searchTerm, getMeds]);

  const handleRowClick = (prod, index) => {
    setSelectedRow(index);
    onSelectProductName(prod);
    handleCloseAll();
  };

  const handleOpenCreateProduct = () => {
    setIsSelectModalVisible(false);
    setIsCreateModalVisible(true);
  };

  const handleCloseCreateProduct = () => {
    setIsCreateModalVisible(false);
    setIsModalOpen(false);
  };

  const handleCloseAll = () => {
    setIsSelectModalVisible(false);
    setIsCreateModalVisible(false);
    onClose();
  };

  return (
    <>
      {isSelectModalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
          onClick={handleCloseAll}
        >
          <div
            style={{
              width: "900px",
              background: "#fff",
              borderRadius: "10px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                padding: "26px 18px 10px 18px",
              }}
            >
              <div>
                <h3 style={{ fontSize: "18px", margin: 0, color: "#1d1d1d", fontWeight: "600" }}>
                  Select a Product
                </h3>
                <p style={{ fontSize: "13px", color: "#777", marginTop: "4px" }}>
                  Start typing to search for products
                </p>
              </div>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <button className="gradient-button" onClick={handleOpenCreateProduct}>
                  Create New
                </button>
                <button
                  onClick={handleCloseAll}
                  style={{
                    fontSize: "18px",
                    border: "none",
                    background: "none",
                    color: "#444",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </div>
            </div>

            {/* Search Input */}
            <div style={{ padding: "16px", borderBottom: "1px solid #eee" }}>
              <div style={{ position: "relative", width: "260px" }}>
                <input
                  type="text"
                  placeholder="Search product name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px 36px 8px 10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                />
                <FiSearch
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#555",
                    fontSize: "18px",
                  }}
                />
              </div>
            </div>

            {/* Table */}
             <div style={{ overflowY: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#f7f7f7ff" }}>
                    <th style={thStyle}>PRODUCT'S NAME/COMPANY</th>
                    <th style={thStyle}>UNITS/PACK</th>
                    <th style={thStyle}>STATUS</th>
                    <th style={thStyle}>MRP</th>
                    <th style={thStyle}>SALE RATE</th>
                    <th style={thStyle}>NET RATE</th>
                    <th style={thStyle}>LOCATION</th>
                  </tr>
                </thead>
                <tbody>
                  {products.length > 0 ? (
                    products.map((prod, i) => (
                      <tr
                        key={i}
                        style={{
                          borderBottom: "1px solid #eee",
                          background:
                            selectedRow === i
                              ? "#ebfcebff"
                              : i % 2 === 0
                              ? "#fff"
                              : "#f9f9f9",
                          cursor: "pointer",
                          transition: "background 0.2s",
                        }}
                        onClick={() => handleRowClick(prod, i)}
                        onMouseEnter={(e) => {
                          if (selectedRow !== i)
                            e.currentTarget.style.background = "#f0f0f0ff";
                        }}
                        onMouseLeave={(e) => {
                          if (selectedRow !== i)
                            e.currentTarget.style.background = "#ffffffff";
                        }}
                      >
                        <td style={tdStyle}>
                          <div
                            style={{
                              fontWeight: 700,
                              color: "#232224",
                              display: "flex",
                            }}
                          >
                            {prod.productName}
                            <MdVerified
                              style={{
                                color: "#2a8a12ff",
                                fontSize: "16px",
                                marginLeft: "8px",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#888",
                              marginTop: "2px",
                            }}
                          >
                            {prod.cmpnyName}
                          </div>
                        </td>
                        <td style={tdStyle}>{prod.unitsPerPack ?? "N/A"}</td>
                        <td style={tdStyle}>
                          <button
                            style={{
                              backgroundColor:
                                prod.status === "In Stock" ? "#28a745" : "#dc3545",
                              color: "#fff",
                              fontWeight: "500",
                              fontSize: "11px",
                              padding: "4px 10px",
                              borderRadius: "20px",
                              display: "inline-block",
                              minWidth: "70px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {prod.status ?? "N/A"}
                          </button>
                        </td>
                        <td style={tdStyle}>{prod.mrp}</td>
                        <td style={tdStyle}>{prod.saleRate ?? "N/A"}</td>
                        <td style={tdStyle}>{prod.netRate ?? "N/A"}</td>
                        <td style={tdStyle}>{prod.location ?? "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" style={emptyStyle}>
                        {searchTerm.trim()
                          ? "No products found"
                          : "Start typing to search for products"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      )}

      {/* Create New Product Modal */}
      <CreateNewProduct
        show={isCreateModalVisible}
        onClose={handleCloseCreateProduct}
        onAddProduct={(newProduct) => setProducts([newProduct, ...products])}
        batchformik={formik}
        setSelectedProduct={setSelectedProduct}
      />
    </>
  );
};

const thStyle = {
  textAlign: "left",
  padding: "10px 14px",
  fontSize: "13px",
  fontWeight: 600,
  color: "#555",
  borderBottom: "1px solid #ddd",
};

const tdStyle = {
  padding: "10px 14px",
  fontSize: "13px",
  fontWeight: "700",
  color: "#232224",
  verticalAlign: "top",
};

const emptyStyle = {
  textAlign: "center",
  padding: "20px",
  color: "#777",
  fontSize: "13px",
};

export default SelectProductName;